import {
  Block,
  FlexGrid,
  FlexGridItem,
  HeadingMedium,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import matsChest from "#/assets/mats-chest.png"
import { IS_MEZO_MAINNET } from "#/shared/constants"

import MatsEmptyStateButton from "./MatsEmptyStateButton"

export default function MatsEmptyState() {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        background: theme.colors.backgroundTertiary,
        padding: `${theme.sizing.scale1200} 0 0 ${theme.sizing.scale1200}`,
        borderRadius: theme.borders.radius500,
      })}
    >
      <FlexGrid
        flexGridColumnCount={2}
        flexGridColumnGap={theme.sizing.scale3200}
        alignItems="center"
      >
        <FlexGridItem paddingBottom={theme.sizing.scale1200}>
          <HeadingMedium marginBottom={theme.sizing.scale600}>
            Begin your journey <br />
            {IS_MEZO_MAINNET ? "" : "with a deposit."}
          </HeadingMedium>
          <ParagraphLarge marginBottom={theme.sizing.scale900}>
            {IS_MEZO_MAINNET
              ? "Start earning on Mezo."
              : "Deposit BTC and start earning mats and use them on testnet."}
          </ParagraphLarge>
          <MatsEmptyStateButton />
        </FlexGridItem>
        <FlexGridItem display="flex" alignItems="flex-end">
          <Block as="img" src={matsChest} />
        </FlexGridItem>
      </FlexGrid>
    </Block>
  )
}
